import axios from 'axios';
import { API_BASE_URL } from '../utils/config';

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export interface UnpaidPrivateLesson {
  attendanceId: string;
  eventId: string;
  eventDate: string;
  startTime: string;
  endTime: string;
  coachName: string;
}

export interface UserPrivateLessonDebt {
  userId: string;
  userName: string;
  userEmail: string;
  unpaidCount: number;
  privateLessonFee?: number | null;
  amountDue?: number | null;
  sessions: UnpaidPrivateLesson[];
}

export interface MyPrivateLessonDebts {
  unpaidCount: number;
  privateLessonFee?: number | null;
  amountDue?: number | null;
  sessions: {
    eventDate: string;
    startTime: string;
    endTime: string;
    coachName: string;
  }[];
}

export interface PrivateLessonReportRow {
  userId: string;
  userName: string;
  userEmail: string;
  privateLessonFee?: number | null;
  totalLessons: number;
  paidCount: number;
  unpaidCount: number;
  totalCollected: number;
  outstandingAmount?: number | null;
}

const attendanceService = {
  getMyPrivateLessonDebts: async (): Promise<MyPrivateLessonDebts> => {
    const response = await axios.get(`${API_BASE_URL}/api/attendance/my-private-lesson-debts`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  getPrivateLessonDebts: async (): Promise<UserPrivateLessonDebt[]> => {
    const response = await axios.get(`${API_BASE_URL}/api/attendance/private-lesson-debts`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  markAsPaid: async (attendanceId: string): Promise<void> => {
    await axios.patch(
      `${API_BASE_URL}/api/attendance/${attendanceId}/mark-paid`,
      {},
      { headers: getAuthHeader() }
    );
  },

  // Admin report: everyone who has attended private lessons, with their fee, counts and balances.
  getPrivateLessonReport: async (): Promise<PrivateLessonReportRow[]> => {
    const response = await axios.get(`${API_BASE_URL}/api/reports/private-lessons`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },
};

export default attendanceService;
